module.exports = __webpack_public_path__ + "media/images/icon-checkbox-white-b5045f7f.svg";